export class DevicesDto{
    deviceId:number;
    deviceCode:string;
    deviceName:string;
    description:string;
    username: string;

    
    
    constructor(deviceId:number,deviceCode:string, deviceName:string,description:string,username:string){

        this.deviceId=deviceId;
        this.deviceCode = deviceCode;
        this.deviceName=deviceName;
        this.description = description;
        this.username = username;

    }
}